/**
 * Renders the small Markdown subset the server emits for reports and the
 * legal pages use (#/## headings, "- " lists, **bold**, `code`, [links](url),
 * backslash escapes). Input is escaped before any markup is added; links
 * only allow https:, mailto: and site-relative targets. DOM-free so it can be
 * unit-tested in Node.
 */

const escape = (value: string) =>
  value.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);

const SAFE_HREF = /^(https:\/\/|mailto:|\/(?!\/))/;

function link(_match: string, label: string, href: string): string {
  if (!SAFE_HREF.test(href)) return label;
  const external = href.startsWith('https://') ? ' rel="noopener noreferrer"' : '';
  return `<a href="${href}"${external}>${label}</a>`;
}

function inline(text: string): string {
  return escape(text)
    .replace(/(?<!\\)`([^`]+)(?<!\\)`/g, '<code>$1</code>')
    .replace(/(?<!\\)\[([^\]]+)(?<!\\)\]\(([^)\s]+)\)/g, link)
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\\([\\`*_[\]|#<>]|&lt;|&gt;)/g, '$1');
}

export function markdownToHtml(markdown: string): string {
  const out: string[] = [];
  let list = false;
  const closeList = () => {
    if (list) out.push('</ul>');
    list = false;
  };
  for (const line of markdown.split('\n')) {
    if (line.startsWith('# ')) {
      closeList();
      out.push(`<h1>${inline(line.slice(2))}</h1>`);
    } else if (line.startsWith('## ')) {
      closeList();
      out.push(`<h2>${inline(line.slice(3))}</h2>`);
    } else if (line.startsWith('- ')) {
      if (!list) out.push('<ul>');
      list = true;
      out.push(`<li>${inline(line.slice(2))}</li>`);
    } else if (line.trim()) {
      closeList();
      out.push(`<p>${inline(line)}</p>`);
    } else closeList();
  }
  closeList();
  return out.join('\n');
}
